module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "showroom_info.def09aa3.svg";